// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import Vuex from 'vuex';
// import GmapVue from 'gmap-vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import App from './App';
import store from './store';
import axiosUserInstance from './helpers/http-common';
import { isIos } from './helpers/common';

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Vuex);

Vue.config.productionTip = false;
Vue.prototype.$http = axiosUserInstance;

// Vue.use(GmapVue, {
//   load: {
//     // [REQUIRED] This is the unique required value by Google Maps API
//     key: 'AIzaSyBT2Y56ZctvJLjefNgusMS9EpizJuQ5o6A',
//     // [OPTIONAL] This is required if you use the Autocomplete plugin
//     // OR: libraries: 'places,drawing'
//     // OR: libraries: 'places,drawing,visualization'
//     // (as you require)
//     // libraries: 'places',

//     // [OPTIONAL] If you want to set the version, you can do so:
//     // v: '3.26',

//     // This option was added on v3.0.0 but will be removed in the next major release.
//     // If you already have an script tag that loads Google Maps API and you want to use it set you callback
//     // here and our callback `GoogleMapsCallback` will execute your custom callback at the end; it must attached
//     // to the `window` object, is the only requirement.
//     // customCallback: 'MyCustomCallback',
//   },

//   // [OPTIONAL] If you intend to programmatically custom event listener code
//   // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
//   // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
//   // you might need to turn this on.
//   autoBindAllEvents: false,

//   // [OPTIONAL] If you want to manually install components, e.g.
//   // import {GmapMarker} from 'gmap-vue/src/components/marker'
//   // Vue.component('GmapMarker', GmapMarker)
//   // then set installComponents to 'false'.
//   // If you want to automatically install all the components this property must be set to 'true':
//   installComponents: true,

//   // Load the Google Maps API dynamically, if you set this to `true` the plugin doesn't load the Google Maps API
//   dynamicLoad: false,
// });

const handleOffline = () => {
  store.dispatch('network/setIsOffline', { isOffline: true });
};

const handleOnline = () => {
  store.dispatch('network/setIsOffline', { isOffline: false });
};

const initNavigatorShare = () => {
  if (!store.getters['device/isBrowser'] && !window.navigator.share) {
    window.navigator.share = window.navigator.sharePlugin;
  }
};

// const subscribeAuthCallbackHandler = () => {
//   window.universalLinks.subscribe('authCallback', (eventData) => {
//     // do some work
//     console.log(`Did launch application from the link: ${eventData.url}`);
//     console.log(eventData);
//   });
// };

const onDeviceReady = () => {
  store.dispatch('device/init', {
    platform: window.device ? window.device.platform : 'browser',
    uuid: window.device ? window.device.uuid : null,
  });

  // Expose the platform to CSS (platform-android / platform-ios / platform-browser)
  const bodyPlatform = window.device ? window.device.platform : 'browser';
  document.body.classList.add(`platform-${bodyPlatform.toLowerCase()}`);

  const mode = (window.device && store.state.device.platform === 'browser') ? 'history' : 'hash';

  document.addEventListener('offline', handleOffline, false);
  document.addEventListener('online', handleOnline, false);

  initNavigatorShare();

  if (window.StatusBar && isIos()) {
    // In native applications make status bar text dark color
    // (it has white background from ap header)
    window.StatusBar.styleDefault();
  }

  import('./router/index').then((getRouter) => {
    const router = getRouter.default(mode);

    // setup basic axios error handling
    axiosUserInstance.interceptors.response.use(
      response => response,
      (error) => {
        if (router.currentRoute.meta.requiresAuth && error.response.status === 401) {
          store.dispatch('auth/logout', { forced: true });
          router.push({
            path: 'login',
            query: { nextUrl: router.currentRoute.fullPath, unauth: 'true' },
          });
        }

        return Promise.reject(error);
      },
    );

    if (window.device && window.device.platform !== 'browser') {
      // firebasex 20.x modular: messaging global replaces the old monolithic FirebasePlugin
      store.dispatch('firebase/setupMessaging', { messagingInstance: window.FirebasexMessaging, vueRouterInstance: router });
      store.dispatch('firebase/onDeviceReadyForFirebase', { vueRouter: router });

      store.dispatch('branch/initSession', { vueRouter: router });
      window.universalLinks.subscribe(null, (eventData) => {
        store.dispatch('universalLinks/handleUL', { vueRouter: router, eventData });
      });

      const onResume = () => {
        store.dispatch('branch/initSession', { vueRouter: router, onResume: true });
      };
      document.addEventListener('resume', onResume, false);
    } else {
      store.dispatch('firebaseAnalytics/init');
    }

    if (store.getters['auth/isAuthenticated']) {
      store.dispatch('firebaseAnalytics/setUser', { userId: store.state.user.id });
      store.dispatch('referrals/init').then().catch().finally(() => {
        // eslint-disable-next-line no-new
        new Vue({
          el: '#app_container',
          store,
          router,
          components: { App },
          template: '<App/>',
        });
      });
    } else {
      // eslint-disable-next-line no-new
      new Vue({
        el: '#app_container',
        store,
        router,
        components: { App },
        template: '<App/>',
      });
    }
  });
};


document.addEventListener('deviceready', onDeviceReady, false);

if (!window.cordova) {
  onDeviceReady();
}



// WEBPACK FOOTER //
// ./src/main.js